import { NgTemplateOutlet } from '@angular/common';
import { Component, TemplateRef, input, viewChild } from '@angular/core';
import { TranslateDirective } from '@ngx-translate/core';
import { IconFlagComponent } from '../../../components/icon/icon-flag.component';
import { BusinessUnit, Account, AccountStatus } from '../../../domain/account.domain';

export type AccountLabelType = 'short' | 'medium' | 'long' | 'single_line_long' | 'short_number_description' | 'two_lines_currency_desc_number';

@Component({
  selector: 'td-wb-account-label',
  templateUrl: 'account-label.component.html',
  styleUrls: ['account-label.component.scss'],
  imports: [
    NgTemplateOutlet,
    IconFlagComponent,
    TranslateDirective
  ]
})
export class AccountLabelComponent {

  readonly account = input<Account>(undefined);
  readonly type = input<AccountLabelType>(undefined);
  readonly shortLabelTemplate = viewChild<TemplateRef<unknown>>('shortLabelTemplate');
  readonly mediumLabelTemplate = viewChild<TemplateRef<unknown>>('mediumLabelTemplate');
  readonly longLabelTemplate = viewChild<TemplateRef<unknown>>('longLabelTemplate');
  readonly singleLineLongLabelTemplate = viewChild<TemplateRef<unknown>>('singleLineLongLabelTemplate');
  readonly shortNumberDescLabelTemplate = viewChild<TemplateRef<unknown>>('shortNumberDescLabelTemplate');
  readonly twoLinesDescNumberLabelTemplate = viewChild<TemplateRef<unknown>>('twoLinesDescNumberLabelTemplate');

  constructor() {
  }

  isAccountClosed(): boolean {
    const account = this.account();
    return account !== undefined && account.status === AccountStatus.CLOSED;
  }

  isOfiOrTdctAccount(): boolean {
    const account = this.account();
    return account.businessUnit === BusinessUnit.OFI || account.businessUnit === BusinessUnit.TDCT;
  }

  getTemplate(): TemplateRef<unknown> {
    switch (this.type()) {
      case 'short':
        return this.shortLabelTemplate();
      case 'medium':
        return this.mediumLabelTemplate();
      case 'long':
        return this.longLabelTemplate();
      case 'single_line_long':
        return this.singleLineLongLabelTemplate();
      case 'short_number_description':
        return this.shortNumberDescLabelTemplate();
      case 'two_lines_currency_desc_number':
        return this.twoLinesDescNumberLabelTemplate();
      default:
        return this.longLabelTemplate();
    }
  }
}
